var _defs, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiltedGrid = function SvgTiltedGrid(props) {
  return /*#__PURE__*/React.createElement("svg", props, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "tilted-grid_svg__pt",
    width: 72,
    height: 56,
    patternUnits: "userSpaceOnUse",
    x: "50%",
    y: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 56V.5H72",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    strokeWidth: 0,
    fill: "url(#tilted-grid_svg__pt)"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: "50%",
    y: 16,
    className: "overflow-visible"
  }, props), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0,
    width: 73,
    height: 57,
    x: 0,
    y: 56
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0,
    width: 73,
    height: 57,
    x: 72,
    y: 168
  }))));
};
export default SvgTiltedGrid;